"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  z50: "#F8F8FB",
  z100: "#E8EAF5",
  z200: "#B3BADA",
  z300: "#717DBA",
  z400: "#3C4886",
  z500: "#2C3875",
  z600: "#242F64",
  z700: "#1A2456",
  z800: "#192045",
  z900: "#060B23"
};
exports["default"] = _default;